<template>
  <div class="DefaultFileInput">
    <span class="LabelSpan">{{ label }}</span>
    <div class="ContainFileUpload">
      <div 
        v-if="type==='avatar' && (modelValue || uploadUrl)"
        class="IconTeacher"
        :style="backgroundImgStyle"
      ></div>
      <div 
        class="FileUploadArea"
        :class="{ ActiveArea: isDragOver }"
        @drop="handleDrop"
        @dragover="handleDragOver"
        @dragleave="handleDragLeave"
      >
        <div class="CustomInput">
          <input 
            type="file" 
            ref="fileInput"
            @change="handleFileSelect"
            class="FileInput"
            :accept="acceptFiles"
          >
          <span class="FileInfo">{{ $t(fileName) }}</span>
          <button 
            style="width: fit-content; height: fit-content; padding: 8px 12px; background: none;"
            @click="$refs.fileInput.click()"
            class="btn-n-white"
          >
            {{ $t(buttonText) }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="uploadUrl && type==='default'" class="UploadedFile">
      <a
        :href="myTransformUrl(uploadUrl)"
        >{{ $t("components.default_file_input.upload_file") }}</a
      >
    </div>
    <div
      v-if="avatarUploadModalShowed"
      class="AvatarUploadModalWrapper"
      @click.self="avatarUploadModalShowed = !avatarUploadModalShowed"
    >
      <div class="AvatarUploadModal">
        <div class="AUContent">
          <div class="AUTitle noselect">
            <span>{{
              $t("pages.ec_edit.form.avatar_upload_modal.title")
            }}</span>
            <div
              class="Close"
              @click.self="avatarUploadModalShowed = !avatarUploadModalShowed"
            ></div>
          </div>

          <ImageCropper
            :fileDataUrl="fileDataUrl"
            :needChangeFile=false
            :getResult="getCroppedAvatar" 
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { transformUrl } from "@/utils/transformUrl.js";
import ImageCropper from "@/components/ImageCropper";

import "@/assets/css/Repainting/Buttons.css";

export default {
  name: 'DefaultFileInput',
  components: {
    ImageCropper
  },
  props: {
    modelValue: {
      type: [Object, String],
      default: ''
    },
    uploadUrl: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'default'
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      fileName: 'components.default_file_input.help_message_area',
      isDragOver: false,
      avatarUploadModalShowed: false,
      fileDataUrl: null
    }
  },
  computed: {
    buttonText() {
      return this.fileName === 'components.default_file_input.help_message_area' ? 
        'components.default_file_input.buttons.download_device' : 
        'components.default_file_input.buttons.edit_file';
    },
    backgroundImgStyle() {
      if (this.modelValue) {
        return {
          background: `url('${this.modelValue}')`,
          backgroundSize: 'contain' // Подстраивает картинку под размер
        };
      }
      else if (this.uploadUrl) {
        return {
          background: `url('${transformUrl(this.uploadUrl)}')`,
          backgroundSize: 'contain' // Подстраивает картинку под размер
        };
      }
      return {};
    },
    acceptFiles() {
      switch (this.type) {
        case 'avatar':
          return "image/png, image/jpeg"
      }

      return '*'
    }
  },
  methods: {
    // Операции при получении файла одним из двух способов
    processFile(file) {
      // Если файл существует, отправляем его родителю
      if (file) {
        // Если обычный тип, то отправляем файл родителю
        if (this.type === 'default') {
          this.fileName = file.name;
          this.$emit('update:modelValue', file);
        }

        // Если тип загружаемого файла аватар, то открываем ImageCropper
        if (this.type === 'avatar') {
          const reader = new FileReader();

          // Как только файл загружен - передаем его в ImageCropper и открываем
          reader.onload = (e) => {
            this.fileDataUrl = e.target.result;
            this.avatarUploadModalShowed = true;
          };
          // Экспортируем file в fileDataUrl в виде base64 строки
          reader.readAsDataURL(file);
        }
      }
      // Если нет, то отправляем null
      else {
        this.fileName = 'components.default_file_input.help_message_area';
        this.$emit('update:modelValue', null);
      }
    },
    // Если файл получен через ImageCropper, отправляем родителю
    getCroppedAvatar(res) {
      this.fileName = 'components.default_file_input.help_message_avatar';
      this.$emit('update:modelValue', res);
      this.fileDataUrl = null;
      this.avatarUploadModalShowed = false;
    },
    // Загрузка файла через кнопку
    handleFileSelect(event) {
      const file = event.target.files[0];
      event.target.value = '';

      this.processFile(file);
    },
    // Загрузка файла через перенос файла в область загрузки
    handleDrop(event) {
      event.preventDefault();
      this.isDragOver = false;
      
      const files = event.dataTransfer.files;
      // Если отправлен хотя бы 1 файл - загружаем первый
      if (files.length > 0) {
        this.processFile(files[0]);
      }
    },
    handleDragOver(event) {
      event.preventDefault();
      this.isDragOver = true;
    },
    handleDragLeave(event) {
      event.preventDefault();
      // Проверяем, что курсор действительно покинул элемент
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.isDragOver = false;
      }
    },
    myTransformUrl(url) {
      return transformUrl(url);
    },
    transformLink(url) {
      return transformUrl(url);
    },
  }
};
</script>

<style scoped>
.DefaultFileInput {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 10px;

  background: #F3F3F3;
  border-radius: 8px;
}
.AUContent {
  position: relative;
  display: flex;

  min-width: 0%;
  width: 100%;

  height: fit-content;
  max-height: 100%;

  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
}
.AUTitle > * {
  margin: auto 0%;
}
.AUTitle {
  position: relative;
  display: flex;

  width: auto;
  max-width: 100%;

  flex-direction: row;
  justify-content: space-between;
  gap: 10px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;

  color: #1a1a1a;
}
.Close {
  position: relative;
  display: block;

  width: 40px;
  height: 40px;

  background: url("./../../../assets/img/ReDesign/interface_icons/close_modal_16px.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;

  border-radius: 8px;
  transition: 0.3s;

  flex-shrink: 0;
}
.Close:hover {
  transition: 0.3s;
  background-color: #f8f8f8;
}
.AvatarUploadModalWrapper {
  position: fixed;
  display: flex;

  inset: 0;

  width: 100%;
  height: 100svh;

  background-color: rgba(26, 26, 26, 0.6);
  backdrop-filter: blur(10px);

  z-index: 2001;
}
.AvatarUploadModal {
  position: relative;
  display: flex;

  margin: auto;
  padding: 40px;

  min-width: 0;
  width: 500px;
  max-width: 95%;

  height: fit-content;
  max-height: 95%;

  border-radius: 24px;
  overflow-y: auto;

  background-color: white;
}
.ContainFileUpload {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  gap: 10px;

  align-items: center;
}
.IconTeacher {
  position: relative;
  display: flex;

  width: 84px;
  height: 84px;

  border-radius: 16px;

  background-color: #fd616133;
  text-decoration: none;

  overflow: hidden;

  flex-shrink: 0;
}
.FileUploadArea {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  align-items: center;
  padding: 24px;
  gap: 10px;

  border: 1px dashed #E0E0E0;
  border-radius: 8px;
}
.ActiveArea {
  background: repeating-linear-gradient(
    135deg,
    #f0f0f0,
    #f0f0f0 10px,
    #ffffff 10px,
    #ffffff 20px
  );
}
.LabelSpan {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #1A1A1A;
}
.UploadedFile a {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #1A1A1A;

  text-decoration: underline;
}
.CustomInput {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.FileInput {
  display: none;
}
.FileInfo {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #666666;

  word-break: break-word;
}
</style>

<style scoped>
@media (max-width: 480px) {
  .ContainFileUpload {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>